<template lang="pug">
a
  .img(:style="{ backgroundImage: 'url(' + img + ')' }")
    .d-flex.justify-content-center.align-items-center
      h3.text-white.mb-0 {{ title }}
</template>

<script>
export default {
  name: "Aviation",
  props: {
    title: String,
    img: String,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/ic_selector/aviation";
</style>
